import React, { useState, useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Grid, Box, CircularProgress, Typography } from '@mui/material';
import { AccountLink, SubTitle, Title } from '../common';
import KenInput from '../../../Components/KenInput';
import KenButton from '../../../Components/KenButton';
import { useNavigate } from 'react-router-dom';
import routes from '../../../Constants/routes';
import Google from '../../../Assets/Svg/google.svg';
import Facebook from '../../../Assets/Svg/facebook.svg';
import LinkedIn from '../../../Assets/Svg/linkedin.svg';
import { AuthBG as LoginBG, AuthMobileBG as MobileLoginBG } from '../../../Assets/authBackground';
import { useForm, Controller } from 'react-hook-form';
import validator from 'validator';
import { requestForOTP } from '../api';
import { useSnackbar } from 'notistack';
import { handleError } from '../util';
import { useMediaQuery } from '@mui/material';
import Carousel from 'nuka-carousel';
import {
  signInWithFacebook,
  signInWithGoogle,
} from '../../../Utils/Helpers/firebaseHelper';
import { getApplicantByEmail } from '../../../Utils/apiServices';
import { AuthContext } from '../../../Context/authContext';
import KenLoader from '../../../Components/KenLoader';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundImage: `url(${LoginBG})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${MobileLoginBG})`,
    },

    // '& form': {
    //   top: () => (1 / window.devicePixelRatio === 1 ? '50%' : 0),
    //   transform: () =>
    //     1 / window.devicePixelRatio === 1 ? 'translateY(-50%)' : 0,
    //   position: () => (1 / window.devicePixelRatio === 1 ? 'relative' : 0),
    // },
  },
  loginContent: {
    backgroundColor: 'white',
    minWidth: 'auto',
    width: '100%',
    maxWidth: '420px',
    minHeight: 'auto',
    alignItems: 'center',
    boxSizing: 'border-box',
    'box-shadow':
      '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    'border-radius': '16px',
    padding: '40px 32px',
    [theme.breakpoints.up('md')]: {
      boxShadow: 'none',
      padding: '48px 40px',
      minWidth: '380px',
    },
    [theme.breakpoints.up('lg')]: {
      boxShadow: 'none',
      padding: '48px 40px',
      minWidth: '420px',
    },
    [theme.breakpoints.up('xl')]: {
      boxShadow: 'none',
      padding: '25px 40px',
      minWidth: '515px',
      minHeight: '-webkit-fill-available'
    },
    [theme.breakpoints.down('sm')]: {
      padding: '48px 32px', // Adjusted padding for smaller screens
      margin: '20px',
      minWidth: '363px',
    },
  },
  title: {
    marginBottom: '16px',
  },
  subTitle: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    // marginBottom: '32px',
    margin: '0 auto 20px',
    display: 'block',
    textAlign: 'center',
    marginTop: '20px',
  },
  logo: {
    height: 54,
  },
  inputFieldLabel: {
    'font-style': 'normal',
    'font-weight': '400',
    'font-size': '14px',
    'line-height': '100%',
    'text-transform': 'capitalize',
    color: '#505F79',
  },
  verify: {
    width: '40%',
    height: '40px',
    // marginBottom: '80px',
    borderRadius: '12px !important',
    fontSize: '16px',
    fontWeight: 600,
    backgroundColor: '#4a006a !important',
    color: 'white !important',
    fontFamily: 'SamsungSharp',
    margin: '0 auto !important',
  },
  signupWith: {
    'font-style': 'normal',
    'font-weight': '400',
    'font-size': '14px',
    'line-height': '100%',
    color: theme.palette.KenColors.neutral100,
  },
  signupWithItem: {
    margin: '0 8px',
    width: '40px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    // boxShadow:
    //   '0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    '& img': {
      height: '24px',
      width: '24px',
    },
    '& img.google': {
      width: '37px',
      height: '40px',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  logoCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 20,
  },
  carousel: {
    marginTop: '15%',
  },
}));

const mobileOrEmail = (id) => {
  //Note strict mode will enable only validation with country code
  if (
    validator.isEmail(id) ||
    validator.isMobilePhone(id, 'en-IN', { strictMode: true })
  ) {
    return true;
  }

  return 'Please enter valid email.';
};

export default function Login() {
  const classes = useStyles();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { dispatch } = useContext(AuthContext);
  const [currentSlide, setCurrentSlide] = useState(0); // State to keep track of the current slide index
  const [showVideo, setShowVideo] = useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await requestForOTP(data);

      if (!res || !res?.success) {
        console.log(res?.errorMessage);
        return enqueueSnackbar(res?.errorMessage || 'Something went wrong', {
          variant: 'error',
        });
      }
      if (res?.success) {
        // alert(res?.OTP);
        navigate(routes.loginOTP, {
          state: {
            id: res.applicantId,
            currentId: data.id,
          },
        });
      }
    } catch (error) {
      handleError(enqueueSnackbar, error);
      setTimeout(() => navigate(routes.signup), 3000);
    } finally {
      setLoading(false);
    }
  };

  const handleFacebook = async () => {
    setPageLoader(true);
    try {
      const res = await signInWithFacebook();
      console.log(res);
      if (res?.user?.email) {
        const applicantRes = await getApplicantByEmail(res?.user?.email);
        if (!applicantRes || !applicantRes?.success) {
          setPageLoader(false);
          return enqueueSnackbar(
            applicantRes?.errorMessage || 'Something went wrong',
            {
              variant: 'error',
            }
          );
        }

        // TODO: load token
        setPageLoader(false);
        dispatch({
          type: 'LOGIN',
          payload: {
            user: {
              applicantEmail: applicantRes?.applicantEmail,
              applicantId: applicantRes?.applicantId,
              applicantName: applicantRes?.applicantName,
              applicantDob: applicantRes?.applicantDob,
              applicantCampus: applicantRes?.applicantCampus,
            },
          },
        });
      }
    } catch (err) {
      console.log(err);
      setPageLoader(false);
    }
  };

  const handleGoogle = async () => {
    try {
      setPageLoader(true);
      const res = await signInWithGoogle();
      if (res?.user?.email) {
        const applicantRes = await getApplicantByEmail(res?.user?.email);
        if (!applicantRes || !applicantRes?.success) {
          setPageLoader(false);
          return enqueueSnackbar(
            applicantRes?.errorMessage || 'Something went wrong',
            {
              variant: 'error',
            }
          );
        }

        // TODO: load token
        setPageLoader(false);
        dispatch({
          type: 'LOGIN',
          payload: {
            user: {
              applicantEmail: applicantRes?.applicantEmail,
              applicantId: applicantRes?.applicantId,
              applicantName: applicantRes?.applicantName,
              applicantDob: applicantRes?.applicantDob,
              applicantCampus: applicantRes?.applicantCampus,
            },
          },
        });
      }
    } catch (err) {
      console.log(err);
      setPageLoader(false);
    }
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: '',
    },
  });

  return (
    <Box
      style={{
        height: '100vh',
        width: '100%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: isSmallScreen ? 'center' : 'flex-end',
        backgroundColor: '#000',
        backgroundImage: isSmallScreen ? 'none' : `url(${LoginBG})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center left',
        backgroundSize: 'contain',
        padding: isSmallScreen ? '16px' : '0 6vw 0 0',
        boxSizing: 'border-box',
      }}
    >
      {/* Always render login content */}
      <Box>
        <form onSubmit={handleSubmit(onSubmit)}>
          {pageLoader && <KenLoader />}
          <Box
            className={classes.loginContent}
            display={'flex'}
            flexDirection="column"
            justifyContent={'flex-start'}
            alignItems="flex-start"
          >
            <Box className={classes.logoCenter}>
              <img
                style={{
                  height: '90px',
                  borderRadius: '12px',
                  width: '150px',
                  objectFit: 'contain',
                }}
                src={
                  'https://infivestoragedev.blob.core.windows.net/infive/SIC.jpeg'
                }
                className={classes.logo}
                alt=""
              />
            </Box>
            {/* <Title className={classes.title} text="Log In" /> */}
            <SubTitle
              className={classes.subTitle}
              text="Please enter your login credentials below to start."
            />
            <Box mb={4} width="100%" style={{ marginTop: '10px' }}>
              <Controller
                name="id"
                control={control}
                rules={{
                  required: 'Email ID is Required.',
                  validate: { mobileOrEmail },
                }}
                render={({ field, fieldState: { error } }) => (
                  <KenInput
                    required
                    name="id"
                    label="Email Id"
                    placeholder="Enter Email ID"
                    labelClassName={classes.inputFieldLabel}
                    error={error?.message || error?.type}
                    {...field}
                  />
                )}
              />
            </Box>
            <KenButton
              variant="primary"
              buttonClass={classes.verify}
              type="submit"
              disabled={loading}
            >
              Verify
            </KenButton>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '49%',
                  transform: 'translate(-50%, -50%)',
                }}
              />
            )}
            <Box
              display={'flex'}
              justifyContent="center"
              width="100%"
              marginTop="20px"
            >
              <AccountLink
                text="Don't have an account?"
                actionText={'Sign up'}
                onAction={() => navigate(routes.signup)}
              />
            </Box>
            {/* <Box
            display={'flex'}
            justifyContent="center"
            alignItems={'center'}
            width="100%"
            style={{ display: 'none' }}
          >
            <Box marginRight={'12px'}>
              <Typography className={classes.signupWith}>
                Or Sign In with
              </Typography>
            </Box>
            <Box display={'flex'} justifyContent="space-around">
              <Box className={classes.signupWithItem}>
                <img
                  className="google"
                  src={Google}
                  alt=""
                  onClick={handleGoogle}
                />
              </Box>
              <Box className={classes.signupWithItem}>
                <img src={Facebook} alt="" onClick={handleFacebook} />
              </Box>
              <Box className={classes.signupWithItem}>
                <img src={LinkedIn} alt="" />
              </Box> 
            </Box>
          </Box> */}
          </Box>
        </form>
      </Box>
    </Box>
  );
}
